import styled from '@emotion/styled';
import { List } from '@mui/material';

export const Container = styled(List)``;

Container.defaultProps = {
  disablePadding: true,
  dense: true,
};
